
import { useEffect, useState } from 'react';
import TitleComponent from './TitleComponent';
import { BarChart,XAxis,YAxis, Bar, ResponsiveContainer,Tooltip } from 'recharts';
import { parseISO } from 'date-fns';
import { round } from '../CommonFunctions';


// project import
const options = { month: 'short', day: 'numeric' };


export default function BarChartComponent({data,searchStartDate,annualPaymentSummary}) {
  const [displayType,setDisplayType] = useState("monthly");
  console.log(data)
  const date=parseISO(searchStartDate)
  function getWeeklyData(dailyData) {
    const weeks = [];
    let weekSum = 0;
    let weekSumLastYear=0;
    let weekStartDate = null;
    let weekEndDate = null;
    
    dailyData.forEach((entry, index) => {
        if (index % 7 === 0) {
            if (weekStartDate) {
                weeks.push({
                  date: `${weekStartDate.toLocaleDateString('en-US',options)}-${weekEndDate.toLocaleDateString('en-US',options)}`,
                    amount: weekSum,
                    lastYearAmount : weekSumLastYear
                });
            }
            weekStartDate = new Date(entry.date);
            weekSum = 0;
            weekSumLastYear=0;
        }
        weekEndDate = new Date(entry.date);
        weekSum += entry.amount;
        weekSumLastYear +=entry.lastYearAmount;
    });

    // Add the last week
    if (weekStartDate) {
        weeks.push({
            date: `${weekStartDate.toLocaleDateString('en-US',options)}-${weekEndDate.toLocaleDateString('en-US',options)}`,
            amount: weekSum,
            lastYearAmount : weekSumLastYear
        });
    }

    return weeks;
}
  const calculateTotalAmount = (data) =>{
    let total=0;
    for(let itr in data){
      const currentRow=data[itr];
      total+=currentRow.amount;
    }
    return total;
  }
  return (
    <>
    <TitleComponent title={`${date.toLocaleDateString('en-US',{month:"long"})} Revenue Statistics`} count={round(calculateTotalAmount(data))} 
    isMoney={true} displayType={displayType} setDisplayType={setDisplayType}/>
    <div style={{ width: '100%', height: 320 }}>
    <ResponsiveContainer>
    <BarChart  data={displayType === "weekly" ? 
    getWeeklyData(data) : displayType === "monthly" ? annualPaymentSummary : data} 
    barCategoryGap="25%" margin={{ top: 10, right: 10, left: 10, bottom: 10 }} >
        <XAxis dataKey= {displayType === "monthly" ? "month" : "date"} />
        <YAxis />
        <Tooltip />
       
        {displayType!=="daily" && <Bar dataKey="lastYearAmount" fill="#ff9999" />}
        {/* FIX ME: Naming the bar ..custom name */}
        <Bar dataKey="amount" fill="#87CEEB" />
    </BarChart>
  
    </ResponsiveContainer>
    </div>
    
    </>
  );
}